import { useParams } from "react-router-dom";
import { SupportPageContentContainer, SupportRecommendedArticlesContainer } from "@platform/features/support";

export function DashboardSupportHomePage() {
  const { id: programId } = useParams<{ id: string }>();

  return (
    <SupportPageContentContainer
      programId={programId}
      description="Browse our categories or use the search to find help on specific topics."
    >
      <SupportRecommendedArticlesContainer programId={programId} />
    </SupportPageContentContainer>
  );
}

export default DashboardSupportHomePage;


